import Modal from "antd/es/modal/Modal";
import MapToolsInMapTable from "../tables/MapToolsInMapTable";
import React from "react";

const MapToolsInMapModal = ({showModal, setShowModal, editMapConfig, setEditMapConfig, deleteTools, setDeleteTools,
                                addTools, setAddTools, tools, setTools}) => {

    const handleOk = () => {
        setShowModal(false);
    };
    const handleCancel = () => {
        setShowModal(false);
    };

    return (
        <>
            <Modal title="Tools Table" open={showModal} onOk={handleOk} onCancel={handleCancel} width={'60%'}>
                <MapToolsInMapTable editMapConfig={editMapConfig} setEditMapConfig={setEditMapConfig}
                                    addTools={addTools} setAddTools={setAddTools}
                                    deleteTools={deleteTools} setDeleteTools={setDeleteTools}
                                    tools={tools} setTools={setTools}/>
            </Modal>
        </>
    )
}
export default MapToolsInMapModal;